/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Tuda8Inputs */

const en__field_enum_tuda_tuda8 = /** @type {(inputs: _Field_Enum_Tuda_Tuda8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische Universität Darmstadt`)
};

const de__field_enum_tuda_tuda8 = /** @type {(inputs: _Field_Enum_Tuda_Tuda8Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Technische Universität Darmstadt`)
};

/**
* | output |
* | --- |
* | "Technische Universität Darmstadt" |
*
* @param {_Field_Enum_Tuda_Tuda8Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_tuda8 = /** @type {((inputs?: _Field_Enum_Tuda_Tuda8Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Tuda8Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_tuda8(inputs)
	return de__field_enum_tuda_tuda8(inputs)
});
export { _field_enum_tuda_tuda8 as "_field_enum_TUDA_TUDA" }